export default __webpack_public_path__ + "static/media/logo2.401ee46f.png";